import React, { useState } from 'react';
import {
    BrowserRouter, Route, Switch,
} from 'react-router-dom';
import LocalizationStorage from '%app/js/common/services/localizationStorage';
import { HeaderOverlayProvider } from './components/Header/HeaderOverlayContext';
import { ConnectedOperatorProvider } from './context/ConnectedOperatorContext';
import Layout from './components/Layout';
import OrganizerTrackingResidencyGuard from './components/OrganizerTrackingResidencyGuard';
import routes from './config/routes';
import readRedesignTranslations from './services/readRedesignTranslations';
import readRedesignFooterLinks from './services/readRedesignFooterLinks';

function App() {
    const locale = LocalizationStorage.getLocalizationContext();
    const [translations] = useState(readRedesignTranslations);
    const [footerLinks] = useState(readRedesignFooterLinks);

    return (
        <BrowserRouter basename={`/${locale}`}>
            <OrganizerTrackingResidencyGuard />
            <HeaderOverlayProvider>
                <ConnectedOperatorProvider>
                    <Layout translations={translations} footerLinks={footerLinks}>
                        <Switch>
                            {routes.map(route => (
                                <Route
                                    key={route.id}
                                    path={route.path}
                                    exact={route.exact}
                                    component={route.component}
                                />
                            ))}
                        </Switch>
                    </Layout>
                </ConnectedOperatorProvider>
            </HeaderOverlayProvider>
        </BrowserRouter>
    );
}

export default App;
